"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("../../../common/js/atoms/Icon"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const translation_1 = require("../../../common/js/helper/translation");
const Paths_1 = require("../../constants/Paths");
const path_1 = require("../../helper/path");
const OfferStore_1 = __importDefault(require("../../stores/OfferStore"));
const InfoBox_1 = __importDefault(require("../InfoBox"));
class OfferInfoBox extends react_1.default.Component {
    componentDidMount() {
        OfferStore_1.default.readOffers();
    }
    render() {
        return (react_1.default.createElement(react_1.default.Fragment, null, OfferStore_1.default.offers.filter((item) => null === (item.orderedAt ?? null)).length > 0 ? (react_1.default.createElement(InfoBox_1.default, { innerHtml: (0, translation_1.t)('dashboard.banner_offer_store.text'), link: react_1.default.createElement("a", { href: (0, path_1.localePath)(Paths_1.PATH_ASSETS_OFFER), className: "znd-info-box__link t-body-small mt-3" },
                (0, translation_1.t)('dashboard.banner_offer_store.read_more'),
                react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.arrowRight })), className: "w-100 mw-100 mb-0" })) : null));
    }
}
exports.default = (0, mobx_react_1.observer)(OfferInfoBox);
